export type BulkProductsTab = 'items' | 'stock';
export type BloomStockFilter = 'all' | 'low';

export const BLOOM_STOCK_LOW_PATH = '/bulk-products?tab=stock&filter=low';

export function parseBulkProductsTab(value: string | null | undefined): BulkProductsTab {
  return value === 'stock' ? 'stock' : 'items';
}

export function parseBloomStockFilter(value: string | null | undefined): BloomStockFilter {
  return value === 'low' ? 'low' : 'all';
}

export function formatBloomStockImportNotice(result: {
  applied_count: number;
  errors: { row: number; sku_number?: string; message: string }[];
}): { severity: 'success' | 'error'; message: string } {
  if (result.errors.length > 0) {
    const failed = result.errors.length;
    const error_list = result.errors
      .map((row) => `row ${row.row}${row.sku_number ? ` (${row.sku_number})` : ''}: ${row.message}`)
      .join('; ');
    return {
      severity: 'error',
      message: `Import not applied. ${failed} error${failed === 1 ? '' : 's'}: ${error_list}`,
    };
  }

  const applied = result.applied_count;
  return {
    severity: 'success',
    message: `Imported ${applied} row${applied === 1 ? '' : 's'}.`,
  };
}
